import { toast } from 'react-toastify'
import moment from 'moment';
import Immutable from 'immutable'
import FileDownload from 'react-file-download'


import { createAxiosInstance, getModificaciones, attachFilesToEntity } from '../utils/helpers'
import { API_URL } from '.'
import * as types from './types'
import history from '../utils/history'
import { displayMessages, uploadFiles } from './common'


export function getSolicitud(id) {
	const axios = createAxiosInstance()
	return (dispatch) => {
		const fn0 = () => axios.get(`${API_URL}/solicitudes/tiquetes-aereos/${id}`)
		Promise.all([fn0()])
		.then(res => {
			const solicitud = res[0].data.solicitud
			const aprobadores = res[0].data.aprobadores
			dispatch({ type: types.OBTENER_SOLICITUD_TIQUETESAEREO, payload: { solicitud, aprobadores } })
		})
		.catch(err => {
			console.log(err)
			displayMessages(dispatch, err)
		})
	}
}




export function displayModalAddCotizacion(show, title, mode, index=null) {
	return (dispatch) => {
		if (show) {
			dispatch({ type: types.MOSTRAR_MODAL_ADICIONAR_COTIZACION_TIQUETESAEREO, payload: { show, title, mode, index } })
		} else {
			dispatch({ type: types.MOSTRAR_MODAL_ADICIONAR_COTIZACION_TIQUETESAEREO, payload: { show } })
		}
	}
}



export function displayModalAddTiquete(show, title, index=null) {
	return (dispatch) => {
		if (show) {
			dispatch({ type: types.MOSTRAR_MODAL_ADICIONAR_TIQUETE, payload: { show, title, index } })
		} else {
			dispatch({ type: types.MOSTRAR_MODAL_ADICIONAR_TIQUETE, payload: { show } })
		}
	}
}


export function displayModalAddAsistencia(show, title, index=null) {
	return (dispatch) => {
		if (show) {
			dispatch({ type: types.MOSTRAR_MODAL_ADICIONAR_ASISTENCIA, payload: { show, title, index } })
		} else {
			dispatch({ type: types.MOSTRAR_MODAL_ADICIONAR_ASISTENCIA, payload: { show } })
		}
	}
}

export function displayModalSelectVersion(show, title, mode, index=null) {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {
		if (show) {
			const solicitud_id = getState().tiquetesaereo.getIn(['solicitud', 'id'])
			axios.get(`${API_URL}/solicitudes/tiquetes-aereos/versiones/${solicitud_id}`)
			.then(res => dispatch({ type: types.MOSTRAR_MODAL_SELECCIONAR_VERSION_TIQUETESAEREO, payload: { show, title, mode, index, data: res.data.versiones } }))
			.catch(err => displayMessages(dispatch, err))
		} else {
			dispatch({ type: types.MOSTRAR_MODAL_SELECCIONAR_VERSION_TIQUETESAEREO, payload: { show } })
		}
	}
}

export function removeCotizacion() {
	return (dispatch) => {
		dispatch({ type: types.REMOVER_COTIZACION_TIQUETESAEREO })
	}
}



export function updateInputs(path, value, id = null, immutable = true) {
	return (dispatch) => {
        if(path === 'solicitud.proyecto_evento' || path === 'solicitud.observaciones' || path.includes('celular') || path.includes('cedula') || path.includes('nombres') || path.includes('apellidos') || path.includes('nacionalidad') || path.includes('pais_expedicion') || path === 'comentario.texto' || path === 'solicitud.observaciones' || path === 'modalAddCotizacion.data.descripcion' || path === 'modalAddTiquete.data.tiquete.aerolinea'){
            const regex = /[!@#$%^&*()_+\[\]{}|;':",.<>?´áéíóúÁÉÍÓÚ¡]/g;
            value = value.replace(regex, "").toUpperCase();
        }

        const fn0 = (d) => d({ type: types.MODIFICAR_INPUTS_SOLICITUD_TIQUETESAEREO1, payload: { path, value, immutable } })
		fn0(dispatch)

        let entity
		const attribute = path.split('.').slice(-1)[0];

        switch (attribute) {
			case 'descripcion':
			case 'cotizado':
                entity = 'Cotizacione'
				break;
            default:
		}
        if (entity) {
            const fn1 = (d) => d({ type: types.ADICIONAR_MODIFICACION_SOLICITUD_TIQUETESAEREO, payload: { id, entity, attribute, value, action: 'edit' } })
            fn1(dispatch)
		}

	}


}





export function addFile(path) {
	return (dispatch, getState) => {
		const data = getState().common.getIn(['modalAddFile', 'data'])
		const errors = []
		if (!data.get('file')) errors.push('No adicionó ningun archivo')
		if (!data.get('clasificacion')) errors.push('No se seleccionó ninguna clasificación')
		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {
			const fn1 = (d) => d({ type: types.ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_TIQUETESAEREO, payload: {path, data} })
			const fn2 = (d) => d({ type: types.OCULTAR_MODAL_AGREGAR_ARCHIVO })
			fn1(dispatch)
			fn2(dispatch)
		}
	}
}

export function editPassportFile() {
	return (dispatch, getState) => {
		let data = getState().common.getIn(['modalAddFile', 'data'])

		const index = getState().common.getIn(['modalAddFile', 'index'])
		const errors = []
		if (!data.get('file')) errors.push('No adicionó ningun archivo')
		if (!data.get('clasificacion')) errors.push('No se seleccionó ninguna clasificación')
		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {

			const fn1 = (d) => d({ type: types.EDITAR_ARCHIVO_PASAPORTE, payload: {index, data} })
			const fn2 = (d) => d({ type: types.OCULTAR_MODAL_AGREGAR_ARCHIVO })

            const path = "flagAdjunto";
            const value = false;

            const fn3 = (d) => d({ type: types.MODIFICAR_INPUTS_SOLICITUD_TIQUETESAEREO1, payload: { path, value } })
			fn1(dispatch)
			fn2(dispatch)
            fn3(dispatch)
		}
	}
}



export function addOrigen(payload, query) {
	return (dispatch, getState) => {
		const path = payload.path.split('.')
		let trayecto = getState().tiquetesaereo.getIn(path) //trayectos.0.origen

		if (trayecto.get('origen') === payload.value.code) {
			toast.warn(`La ubicacion ${payload.value.fullname} ya se encuentra en el listado`, { bodyClassName: 'toastify-content toastify-warning' })
		} else {
			trayecto = trayecto.toJS()
			trayecto.origen = payload.value.code
			trayecto.aeropuerto_origen = payload.value.name + ' ' + query.toUpperCase()
			payload.value = trayecto
			dispatch({ type: types.ADICIONAR_ELEMENTO_LISTA_SOLICITUD_TIQUETESAEREO1, payload })
		}
	}
}



export function addDestino(payload, query) {
	return (dispatch, getState) => {
		const path = payload.path.split('.')
		let trayecto = getState().tiquetesaereo.getIn(path)

		if (trayecto.get('destino') === payload.value.code) {
			toast.warn(`La ubicacion ${payload.value.fullname} ya se encuentra en el listado`, { bodyClassName: 'toastify-content toastify-warning' })
		} else {
			trayecto = trayecto.toJS()
			trayecto.destino = payload.value.code
			trayecto.aeropuerto_destino = payload.value.name + ' ' + query.toUpperCase()
			payload.value = trayecto
			dispatch({ type: types.ADICIONAR_ELEMENTO_LISTA_SOLICITUD_TIQUETESAEREO1, payload })
		}
	}
}

export function activateVersion(viaje_id) {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {
		const solicitud_id = getState().tiquetesaereo.getIn(['solicitud', 'id'])
		axios.post(`${API_URL}/solicitudes/tiquetes-aereos/activate-version/${solicitud_id}`, {
			viaje_id
		}).then(res => {
			const solicitud = res.data.solicitud
			const aprobadores = res.data.aprobadores
			dispatch({ type: types.OBTENER_SOLICITUD_TIQUETESAEREO, payload: { solicitud, aprobadores } })
			toast.success('Los cambios han sido guardados exitosamente', { bodyClassName: 'toastify-content toastify-success' })
		}).catch(err => displayMessages(dispatch, err))
		.finally(() => dispatch(displayModalSelectVersion(false)))
	}
}

export function addTrayecto() {
	return {
		type: types.ADICIONAR_TRAYECTO1
	}
}

export function removeTrayectos() {
	return {
		type: types.REMOVER_TRAYECTOS1,
	}
}

export function addCencoSolicitud() {
	return {
		type: types.ADICIONAR_NUEVO_CENCO_SOLICITUD_TIQUETESAEREO1
	}
}

export function removeCenco() {
	return {
		type: types.REMOVER_CENCOS_TIQUETESAEREOS1,
	}
}

export function addPasajero(payload) {
	return (dispatch, getState) => {
		const path = payload.path.split('.')
		let pasajero = getState().tiquetesaereo.getIn(path)
		if (pasajero.get('id') === payload.value.id) {
			toast.warn(`La persona ${payload.value.fullname} ya se encuentra en el listado`, { bodyClassName: 'toastify-content toastify-warning' })
		} else {
			pasajero = pasajero.toJS()
			pasajero = {...pasajero, ...payload.value}
			pasajero.correo = pasajero.email
			pasajero.cedula = pasajero.username
			payload.value = pasajero
			dispatch({ type: types.ADICIONAR_ELEMENTO_LISTA_SOLICITUD_TIQUETESAEREO1, payload })
		}
	}
}


export function addOrEditCotizacion() {
	return (dispatch, getState) => {

		const cotizacion = getState().tiquetesaereo.getIn(['modalAddCotizacion', 'data'])

		const errors = validateCotizacion(cotizacion)

		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {

			const data = getState()
				.tiquetesaereo
				.getIn(['modalAddCotizacion', 'data'])
				.set('fecha_entrega', moment().format('YYYY-MM-DD'))
				.set('estado', 4)

			const fn0 = (d) => d({ type: types.ADICIONAR_COTIZACION_TIQUETESAEREO, payload: { data } })
			const fn1 = (d) => d({ type: types.MOSTRAR_MODAL_ADICIONAR_COTIZACION_TIQUETESAEREO, payload: { show: false } })


			fn0(dispatch)
			fn1(dispatch)

		}


	}
}





export function editPasajero(index) {

	return (dispatch, getState) => {

		const data = getState().tiquetesaereo.getIn(['modalAddTiquete', 'data'])

		const errors = validateTiquete(data)

		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {
			const fn0 = (d) => d({ type: types.MODIFICAR_TIQUETE, payload: { index, data } })
			const fn1 = (d) => d({ type: types.MOSTRAR_MODAL_ADICIONAR_TIQUETE, payload: { show: false } })
			fn0(dispatch)
			fn1(dispatch)
		}
	}
}



export function editAsistencia(index) {

	return (dispatch, getState) => {

		const data = getState().tiquetesaereo.getIn(['modalAddAsistencia', 'data'])

		const errors = validateAsistencia(data)

		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {
			const fn0 = (d) => d({ type: types.MODIFICAR_ASISTENCIA, payload: { index, data } })
			const fn1 = (d) => d({ type: types.MOSTRAR_MODAL_ADICIONAR_ASISTENCIA, payload: { show: false } })
			fn0(dispatch)
			fn1(dispatch)
		}
	}
}

export function updateTravel() {
	const axios = createAxiosInstance()

	return (dispatch, getState) => {

		const fn0 = (d) => d({ type: types.DESHABILITAR_BOTON_SALVAR_SOLICITUD_TIQUETESAEREO, payload: true })
		const fn1 = (d) => d({ type: types.DESHABILITAR_BOTON_SALVAR_SOLICITUD_TIQUETESAEREO, payload: false })
		fn0(dispatch)

		const solicitud_id = getState().tiquetesaereo.get('id')
		const solicitudNew = getState().tiquetesaereo.get('solicitud')
		const solicitudOld = getState().tiquetesaereo.get('unchaged')

		let files = []
		const errors = validateSolicitud(solicitudNew)

		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {
			const modificaciones = addModificaciones(solicitudNew, solicitudOld)
			const esModPasajero = modificaciones.filter(x => x["entity"] === "Pasajero").length
			if (esModPasajero) {
				files = attachFilesToEntity("Pasajero", solicitudNew.getIn(['viaje', 'pasajeros']))
			}

			if (getModificaciones(solicitudNew, solicitudOld, 'Solicitude', switchDocumento) == 0) {
				fn1(dispatch)
				return false
			}

			axios.put(`${API_URL}/solicitudes/tiquetes-aereos/update-travel/${solicitud_id}`, modificaciones)
			.then(res => {
				const solicitud = res.data.solicitud
				const aprobadores = res.data.aprobadores
				const fn2 = (d) => d({ type: types.ACTUALIZAR_SOLICITUD_TIQUETESAEREO, payload: { solicitud, aprobadores } })
				const fn3 = () => history.push(window.FOLDER + '/solicitudes/abiertas')
				const fn4 = () => toast.success('Los cambios han sido guardados exitosamente', { bodyClassName: 'toastify-content toastify-success' })

				dispatch(uploadFiles(`/solicitudes/tiquetes-aereos/uploadPassport/${solicitud_id}`, files, [fn2, fn3, fn4]))

			})
			.catch(err => {
				displayMessages(dispatch, err)
				fn1(dispatch)
			})

		}

	}
}

export function updateTiquetesAereo() {

	const axios = createAxiosInstance()

	return (dispatch, getState) => {

		const fn0 = (d) => d({ type: types.DESHABILITAR_BOTON_SALVAR_SOLICITUD_TIQUETESAEREO, payload: true })
		const fn1 = (d) => d({ type: types.DESHABILITAR_BOTON_SALVAR_SOLICITUD_TIQUETESAEREO, payload: false })
		fn0(dispatch)

		const solicitud = getState().tiquetesaereo.get('id')
		const solicitudNew = getState().tiquetesaereo.get('solicitud')
		const solicitudOld = getState().tiquetesaereo.get('unchaged')

		let files = []

		files = attachFilesToEntity('Cotizacione', solicitudNew.get('cotizaciones'))

		const errors = validateSolicitud(solicitudNew)

		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {

			const modificaciones = getModificaciones(solicitudNew, solicitudOld, 'Solicitude', switchDocumento)

			axios.put(`${API_URL}/solicitudes/tiquetes-aereos/${solicitud}`, modificaciones)
			.then(res => {
				const solicitud = res.data.solicitud
				const aprobadores = res.data.aprobadores
				const fn2 = (d) => d({ type: types.ACTUALIZAR_SOLICITUD_TIQUETESAEREO, payload: { solicitud, aprobadores } })
				const fn3 = () => history.push(window.FOLDER + '/solicitudes/abiertas')
				const fn4 = () => toast.success('Los cambios han sido guardados exitosamente', { bodyClassName: 'toastify-content toastify-success' })
				dispatch(uploadFiles(`/files/${res.data.solicitud.id}`, files, [fn2, fn3, fn4]))
			})
			.catch(err => {
				displayMessages(dispatch, err)
				fn1(dispatch)
			})

		}

	}
}


export function seleccionarAprobacion(indexAprobador, indexAprobacion) {
	return (dispatch) => {
		dispatch({ type: types.SELECCIONAR_APROBACION_SOLICITUD_TIQUETESAEREO, payload: {indexAprobador, indexAprobacion} })
	}
}

export function registerApprovalResult(aprobaciones, result) {

	const ip = require('ip');
	const axios = createAxiosInstance()
	return (dispatch, getState) => {

		const solicitud = getState().tiquetesaereo.get('solicitud')

		const errors = result > 0 ? validateAprobacion(aprobaciones, result) : validateAprobacion(aprobaciones.first().get('observaciones'), result)

		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {

			const modificaciones = []

			aprobaciones.map(a => {
				modificaciones.push({
					id: a.get('id'),
					entity: 'Aprobacione',
					value: { estado: result > 0 ? (a.get('estado') == 1 ? 0 : a.get('estado')) : 0, ip: ip.address(), observaciones: aprobaciones.first().get('observaciones') },
					action: 'edit'
				})
			})


			const disCencos = solicitud.getIn(['viaje', 'cencos'])


			disCencos.map(c => {
				if (c.getIn(['pivot', 'rubro_id'])) {
					modificaciones.push({
						id: c.getIn(['pivot', 'id']),
						entity: 'DisCencoViaje',
						value: { rubro_id: c.getIn(['pivot', 'rubro_id']) },
						action: 'edit'
					})
				}
			})

			axios.put(`${API_URL}/solicitudes/tiquetes-aereos/${solicitud.get('id')}`, modificaciones)
				.then(res => {
					const solicitud = res.data.solicitud
					const aprobadores = res.data.aprobadores
					const fn0 = (d) => d({ type: types.ACTUALIZAR_SOLICITUD_TIQUETESAEREO, payload: { solicitud, aprobadores } })
					fn0(dispatch)

					displayMessages(dispatch, { success: 'La solicitud ha sido guardada exitosamente' })

				})
				.catch(err => {
					console.log(err)
					displayMessages(dispatch, err)
				})

		}
	}
}



export function registerTiquetes() {

	const axios = createAxiosInstance()
	return (dispatch, getState) => {

		const solicitud = getState().tiquetesaereo.get('solicitud')

		const modificaciones = []
		let files

		let tiquetes = Immutable.List()

		const pasajeros = solicitud.getIn(['viaje', 'pasajeros'])

		const errors = validateTiquetes(pasajeros)

		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {

			pasajeros.map(p => {

				tiquetes = tiquetes.push(p.get('tiquete'))

				p = p.deleteIn(['tiquete', 'adjunto'])

				modificaciones.push({
					id: p.getIn(['tiquete', 'id']),
					entity: 'Tiquete',
					value: p.get('tiquete'),
					action: 'edit'
				})

				p.getIn(['tiquete', 'itinerarios']).map(i => {
					modificaciones.push({
						id: i.get('id'),
						entity: 'Itinerario',
						value: i,
						action: 'edit'
					})
				})

			})

			files = attachFilesToEntity('Tiquete', tiquetes)

			axios.put(`${API_URL}/solicitudes/tiquetes-aereos/${solicitud.get('id')}`, modificaciones)
			.then(res => {
				const solicitud = res.data.solicitud
				const aprobadores = res.data.aprobadores
				const fn2 = (d) => d({ type: types.ACTUALIZAR_SOLICITUD_TIQUETESAEREO, payload: { solicitud, aprobadores } })
				const fn3 = () => history.push(window.FOLDER + '/solicitudes/abiertas')
				const fn4 = () => toast.success('Los cambios han sido guardados exitosamente', { bodyClassName: 'toastify-content toastify-success' })
				dispatch(uploadFiles(`/files/${res.data.solicitud.id}`, files, [fn2, fn3, fn4]))
			})
			.catch(err => {
				console.log(err)
				displayMessages(dispatch, err)
			})


		}

	}
}


export function registerAsistencias() {

	const axios = createAxiosInstance()
	return (dispatch, getState) => {

		const solicitud = getState().tiquetesaereo.get('solicitud')

		const modificaciones = []
		let files

		let asistencias = Immutable.List()

		const pasajeros = solicitud.getIn(['viaje', 'pasajeros'])

		const errors = validateAsistencias(pasajeros)

		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {

			pasajeros.map(p => {

				asistencias = asistencias.push(p.get('asistencia'))

				p = p.deleteIn(['asistencia', 'adjunto'])

				modificaciones.push({
					id: p.getIn(['asistencia', 'id']),
					entity: 'PasajeroAsistencia',
					value: p.get('asistencia'),
					action: 'edit'
				})
			})

			files = attachFilesToEntity('PasajeroAsistencia', asistencias)

			axios.put(`${API_URL}/solicitudes/tiquetes-aereos/${solicitud.get('id')}`, modificaciones)
			.then(res => {
				const solicitud = res.data.solicitud
				const aprobadores = res.data.aprobadores
				const fn2 = (d) => d({ type: types.ACTUALIZAR_SOLICITUD_TIQUETESAEREO, payload: { solicitud, aprobadores} })
				const fn3 = () => history.push(window.FOLDER + '/solicitudes/abiertas')
				const fn4 = () => toast.success('Los cambios han sido guardados exitosamente', { bodyClassName: 'toastify-content toastify-success' })
				dispatch(uploadFiles(`/files/${res.data.solicitud.id}`, files, [fn2, fn3, fn4]))
			})
			.catch(err => {
				console.log(err)
				displayMessages(dispatch, err)
			})

		}

	}
}

export function registerTiquetesExpirados() {

	const axios = createAxiosInstance()
	return (dispatch, getState) => {

		const solicitud = getState().tiquetesaereo.get('solicitud')

		let itinerarios = Immutable.List()

		//const hoy = new Date(2019, 5, 15)
		const hoy = new Date()


		solicitud.getIn(['viaje', 'pasajeros']).map(p => {
			p.getIn(['tiquete', 'itinerarios']).filter(i => moment(i.get('fecha_salida')) < moment(hoy)).map(x => {
				itinerarios = itinerarios.push(x.set('numero_tiquete', p.getIn(['tiquete', 'numero_tiquete'])))
			})
		})

		const errors = validateTiquetesExpirados(itinerarios)

		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {

			const modificaciones = []

			itinerarios.map(i => {
				modificaciones.push({
					id: i.get('id'),
					entity: 'Itinerario',
					value: { cumplido: i.get('cumplido'), observaciones: i.get('observaciones') },
					action: 'edit'
				})
			})

			axios.put(`${API_URL}/solicitudes/tiquetes-aereos/${solicitud.get('id')}`, modificaciones)
			.then(res => {
				const solicitud = res.data.solicitud
				const aprobadores = res.data.aprobadores
				const fn0 = (d) => d({ type: types.ACTUALIZAR_SOLICITUD_TIQUETESAEREO, payload: { solicitud, aprobadores } })
				const fn1 = () => toast.success('Los cambios han sido guardados exitosamente', { bodyClassName: 'toastify-content toastify-success' })
				fn0(dispatch)
				fn1()
			})
			.catch(err => {
				console.log(err)
				displayMessages(dispatch, err)
			})

		}


	}
}


export function registerCancelacion() {

	const axios = createAxiosInstance()

	return (dispatch, getState) => {

		//const solicitud = getState().solicitudhoteles.get('solicitud').set('estado', 0)
		const solicitud = getState().tiquetesaereo.get('solicitud')

		const errors = validateSolicitud(solicitud, {cancelar: true})

		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {

			const modificaciones = []

			modificaciones.push({
				id: solicitud.get('id'),
				entity: 'Solicitude',
				value: { motivo_cancelacion: solicitud.get('motivo_cancelacion'), fecha_cancelacion: moment().format('YYYY-MM-DD') },
				action: 'edit'
			})

			axios.put(`${API_URL}/solicitudes/tiquetes-aereos/${solicitud.get('id')}`, modificaciones)
			.then(res => {
				const solicitud = res.data.solicitud
				const aprobadores = res.data.aprobadores
				const fn0 = (d) => d({ type: types.ACTUALIZAR_SOLICITUD_TIQUETESAEREO, payload: { solicitud, aprobadores } })
				const fn1 = () => toast.success('Los cambios han sido guardados exitosamente', { bodyClassName: 'toastify-content toastify-success' })
				fn0(dispatch)
				fn1()
			})
			.catch(err => {
				console.log(err)
				displayMessages(dispatch, err)
			})

		}

	}
}


export function descargarAsistencia() {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {

		const solicitud = getState().tiquetesaereo.get('solicitud')

		axios
		.get(`${API_URL}/solicitudes/tiquetes-aereos/asistencia/descargar/${solicitud.get('id')}`, { responseType: 'arraybuffer'})
		.then((res) => {
			FileDownload(res.data, `asistencia_${solicitud.get('id')}.pdf`);
		})
		.catch((err) => {
			console.log(err)
			displayMessages(dispatch, err)
		})

	}
}


export function enviarComentario() {
    const axios = createAxiosInstance()
	return (dispatch, getState) => {
        const solicitud_id = getState().tiquetesaereo.getIn(['solicitud', 'id'])
		const usuario_id = getState().common.getIn(['user', 'id'])
		const id = getState().tiquetesaereo.getIn(['comentario','id'])
		const comentario = getState().tiquetesaereo.getIn(['comentario','texto'])
        const modificaciones = []

		if (id == null) {

			modificaciones.push({
				entity: 'Foro',
				action: 'add',
				id: null,
				value: {
					solicitud_id,
					usuario_id,
					comentario
				}
			})

		} else {

			modificaciones.push({
				id,
				entity: 'Foro',
				value: { comentario },
				action: 'edit'
			})
		}

		const fn1 = (d) => d({ type: types.DESHABILITAR_BOTON_ENVIAR_COMENTARIO_TIQUETESAEREO1, payload: true })
		const fn2 = (d) => d({ type: types.DESHABILITAR_BOTON_ENVIAR_COMENTARIO_TIQUETESAEREO1, payload: false })

		fn1(dispatch)
		axios.put(`${API_URL}/solicitudes/tiquetes-aereos/${solicitud_id}`, modificaciones)
		.then(res => {
			const foros = res.data.solicitud.foros
			const fn3 = (d) => d({ type: types.ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_TIQUETESAEREO1, payload: { foros } })
			fn3(dispatch)
			fn2(dispatch)
		})
		.catch(err => {
			displayMessages(dispatch, err)
			fn2(dispatch)
		})
	}
}

export function editarComentario( id ) {
	return (dispatch) => {
		const fn1 = (d) => d({ type: types.EDITAR_COMENTARIO_SOLICITUD_TIQUETESAEREO1, payload: { id } })
		fn1(dispatch)
	}
}

export function eliminarComentario(id) {
    const axios = createAxiosInstance()
	return (dispatch, getState) => {
        const solicitud = getState().tiquetesaereo.getIn(['solicitud', 'id'])
        const modificaciones = []
		modificaciones.push({ entity: 'Foro', id, action: 'delete', value: null})
        axios.put(`${API_URL}/solicitudes/tiquetes-aereos/${solicitud}`, modificaciones)
        .then(res => {
			const foros = res.data.solicitud.foros
			const fn1 = (d) => d({ type: types.ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_TIQUETESAEREO1, payload: { foros } })
            fn1(dispatch)
			displayMessages(dispatch, { success: 'Las eliminaciones han sido realizadas exitosamente' })
        })
        .catch(err => {
            displayMessages(dispatch, err)
        })
	}
}


///******* Shared ********///


const validateSolicitud = (data, extra=null) => {
	const errors = []
	if (extra && extra.cancelar && !data.get('motivo_cancelacion')) errors.push('El campo motivo cancelación es obligatorio')
	return errors
}


const validateCotizacion = (data) => {
	const errors = []
	if (!data.get('descripcion')) errors.push('El campo aerolínea es obligatorio')
	if (!data.get('cotizado') || data.get('cotizado') <= 0) errors.push('El campo valor cotizado es obligatorio')
	if (!data.getIn(['adjunto', 'file'])) errors.push('El campo pantallazo cotización es obligatorio')
	return errors
}


// const validateAprobacion = (data) => {
// 	const errors = []
// 	if (data && data.get('estado') == 2 && !data.get('selected')) errors.push('Debe seleccionar una cotización para aprobar')
// 	if (data && data.get('estado') == 0 && !data.get('observaciones')) errors.push('El campo observaciones es obligatorio')
// 	return errors
// }




const validateAprobacion = (data, extra) => {
	const errors = []
	if (extra == 2 && data.filter(x => x.get('estado') == 2).count() == 0) errors.push('Debe seleccionar una cotización para aprobar')
	if (extra == 2 && data.filter(x => x.get('estado') == 2).count() > 1) errors.push('Sólo xdbe seleccionar una cotización para aprobar')
	if (extra == 0 && !data) errors.push('El campo observaciones es obligatorio si va a rechazar las cotizaciones')



	return errors
}




const validateTiquete = (data) => {

	const errors = []

	if (!data.getIn(['tiquete', 'aerolinea'])) errors.push('El campo aerolínea es obligatorio')
	if (!data.getIn(['tiquete', 'numero_tiquete'])) errors.push('El campo número tiquete es obligatorio')
	if (!data.getIn(['tiquete', 'fecha_compra'])) errors.push('El campo fecha de compra es obligatorio')
	if (!data.getIn(['tiquete', 'valor_pagado'])) errors.push('El campo valor es obligatorio')
	if (!data.getIn(['tiquete', 'adjunto', 'file'])) errors.push('El campo tiquete es obligatorio')

	const tipo_trayecto = data.getIn(['viaje', 'tipo_trayecto'])

	data.getIn(['tiquete', 'itinerarios']).map(i => {

		if (i.get('fecha_salida').split(" ")[0] == "") errors.push('El campo fecha salida es obligatorio')
		if (i.get('fecha_salida').split(" ")[1] == "") errors.push('El campo hora salida es obligatorio')

		if (tipo_trayecto == 1) {
			if (i.get('fecha_llegada').split(" ")[0] == "") errors.push('El campo fecha llegada es obligatorio')
			if (i.get('fecha_llegada').split(" ")[1] == "") errors.push('El campo hora llegada es obligatorio')
		}

	})


	if (data.getIn(['tiquete', 'fecha_compra']) && moment(data.getIn(['tiquete', 'fecha_compra'])) > moment(new Date()))
		errors.push('La fecha de compra debe ser menor o igual a la fecha actual')

	return errors
}



const validateAsistencia = (data) => {

	const errors = []
	if (!data.getIn(['asistencia', 'numero_voucher'])) errors.push('El campo número voucher es obligatorio')
	if (!data.getIn(['asistencia', 'fecha_compra'])) errors.push('El campo fecha de compra es obligatorio')
	if (!data.getIn(['asistencia', 'valor'])) errors.push('El campo valor es obligatorio')


	if (!data.getIn(['asistencia', 'adjunto', 'id']) && !data.getIn(['asistencia', 'adjunto', 'file']))
		errors.push('El campo voucher es obligatorio')


	if (data.getIn(['asistencia', 'fecha_compra']) && moment(data.getIn(['asistencia', 'fecha_compra'])) > moment(new Date()))
		errors.push('La fecha de compra debe ser menor o igual a la fecha actual')

	return errors
}


const validateTiquetes = (data) => {
	const errors = []
	data.map((p,i) => {
		if (validateTiquete(p).length > 0) {
			errors.push(`Faltan datos en pasajero No. ${i+1}`)
		}
	})


	return errors
}



const validateAsistencias = (data) => {
	const errors = []
	data.map((p,i) => {
		const validaciones = validateAsistencia(p)
		if (validaciones.length > 0) {
			errors.push(`Faltan datos en pasajero No. ${i+1}`)
		}
	})
	return errors
}


const validateTiquetesExpirados = (data) => {
	const errors = []
	data.map(t => {
		if (t.get('cumplido') == null) errors.push(`El campo cumplido es obligatorio en el tiquete No. ${t.get('numero_tiquete')}`)
		if ((t.get('cumplido') == 0) && (!t.get('observaciones'))) errors.push(`El campo observaciones es obligatorio en el tiquete No. ${t.get('numero_tiquete')}`)
	})
	return errors
}


const switchDocumento = (change, modificacion) => {

	const path = [...modificacion.attribute]

	modificacion.attribute = path[0]

	if (modificacion.attribute === 'responsable_compras') {
		modificacion.action = 'hidden'
	}

	switch (change.get('op')) {

		case 'add':

			if (modificacion.attribute === 'cotizaciones') {
				modificacion.action = 'create'
			}

			if (modificacion.attribute === 'adjunto') {
				modificacion.action = 'hidden'
			}
			if (modificacion.attribute === 'viaje') {
				modificacion.action = 'hidden'
			}

			break
		case 'replace':
			if (modificacion.attribute === 'viaje') {
				modificacion.action = 'hidden'
			}
			break
		case 'remove':
			if (modificacion.attribute === 'cotizaciones') {
				modificacion.action = 'detach'
			}
			break
	}
}

const switchEditSolicitud = (change, modificacion) => {

	const path = [...modificacion.attribute]

	modificacion.attribute = path[0]

	if (modificacion.attribute === 'responsable_compras') {
		modificacion.action = 'hidden'
	}

	switch (change.get('op')) {

		case 'add':

			if (modificacion.attribute === 'cotizaciones') {
				modificacion.action = 'hidden'
			}

			if (modificacion.attribute === 'adjunto') {
				modificacion.action = 'hidden'
			}
			if (modificacion.attribute === 'viaje') {
				modificacion.action = 'hidden'
			}

			break
		case 'replace':
			if (modificacion.attribute === 'viaje') {
				modificacion.action = 'hidden'
			}
			break
		case 'remove':
			if (modificacion.attribute === 'cotizaciones') {
				modificacion.action = 'hidden'
			}
			break
	}
}

const switchViaje = (change, modificacion) => {
	const path = [...modificacion.attribute]
	modificacion.attribute = path[0]

	switch (change.get('op')) {

		case 'add':
			if (modificacion.attribute === 'cencos') {
				modificacion.action = 'hidden'
			}
			if (modificacion.attribute === 'trayectos') {
				modificacion.action = 'hidden'
			}
			if (modificacion.attribute === 'pasajeros') {
				modificacion.action = 'hidden'
			}
			if (modificacion.attribute === 'tiquetes') {
				modificacion.action = 'hidden'
			}
			break
		case 'replace':
			if (modificacion.attribute === 'cencos') {
				modificacion.action = 'hidden'
			}
			if (modificacion.attribute === 'trayectos') {
				modificacion.action = 'hidden'
			}
			if (modificacion.attribute === 'pasajeros') {
				modificacion.action = 'hidden'
			}
			if (modificacion.attribute === 'tiquetes') {
				modificacion.action = 'hidden'
			}
			break
		case 'remove':

			break
	}
}

const addModificaciones = (solicitud, unchaged) => {
	let modificaciones = []
	solicitud.set('created_at', moment().format("YYYY-MM-DD HH:ii:ss"))
	modificaciones = [...getModificaciones(solicitud, unchaged, 'Solicitude', switchEditSolicitud)]
	const modificacionesViajes = getModificaciones(
		solicitud.get('viaje'),
		unchaged.get('viaje'),
		'Viaje',
		switchViaje
	)

	modificaciones = [...modificaciones, ...modificacionesViajes]
	solicitud.getIn(["viaje", "cencos"]).valueSeq().forEach(c => {
		modificaciones = [...modificaciones, {
			entity: "DisCencoViaje",
			value: {
				viaje_id: solicitud.getIn(['viaje', 'id']),
				cenco_id: c.get('id'),
				porcentaje: c.getIn(["pivot", "porcentaje"])
			},
			action: 'add'
		}]
	})

	solicitud.getIn(["viaje", "trayectos"]).valueSeq().forEach(t => {
		modificaciones = [...modificaciones, {
			entity: "Trayecto",
			value: {
				viaje_id: solicitud.getIn(['viaje', 'id']),
				origen: t.get('origen'),
				aeropuerto_origen: t.get('aeropuerto_origen'),
				fecha_ida: t.get('fecha_ida') && t.get('fecha_ida') != "0000-00-00 00:00:00" && t.get('hora_ida') ? `${moment(t.get('fecha_ida')).format("YYYY-MM-DD")} ${t.get('hora_ida')}` : "",
				destino: t.get('destino'),
				aeropuerto_destino: t.get('aeropuerto_destino'),
				fecha_regreso: t.get('fecha_regreso') && t.get('fecha_regreso') != "0000-00-00 00:00:00" && t.get('hora_regreso') ? `${moment(t.get('fecha_regreso')).format("YYYY-MM-DD")} ${t.get('hora_regreso')}` : "",
			},
			id: null,
			action: "add"

		}]
	})

	solicitud.getIn(["viaje", "pasajeros"]).valueSeq().forEach(p => {
		modificaciones = [...modificaciones, {
			entity: "Pasajero",
			value: {
				tipo_pasajero: p.get('tipo_pasajero'),
				nombres: p.get('nombres'),
				apellidos: p.get('apellidos'),
				cedula: p.get('cedula'),
				correo: p.get('correo'),
				fecha_nacimiento: p.get('fecha_nacimiento'),
				celular: p.get('celular'),
				pasaporte: p.get('pasaporte'),
				pasaporte_adjunto: p.get('pasaporte_adjunto'),
				nacionalidad: p.get('nacionalidad'),
				pais_expedicion: p.get('pais_expedicion'),
				fecha_caducidad_pasaporte: p.get('fecha_caducidad_pasaporte'),
				viaje_id: solicitud.getIn(['viaje', 'id']),
				guid: p.get('guid'),
				asistencia: p.get('asistencia'),
                tipo_documento : p.get('tipo_documento')
			},
			id: "",
			action: "add"
		}]
	})

	return modificaciones
}

export function removeSolicitudTiqutesAereos() {
	return (dispatch) => {
		dispatch({ type: types.ELIMINAR_ARCHIVOS_SOLICITUD_TIQUETESAEREO })
	}
}

export function addFileAdjunto(){
    return (dispatch, getState) => {
        const data = getState().common.getIn(['modalAddFile', 'data'])
		const errors = []
		if (!data.get('file')) errors.push('No adicionó ningun archivo')
		if (!data.get('clasificacion')) errors.push('No se seleccionó ninguna clasificación')
		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {
			const fn1 = (d) => d({ type: types.ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_TIQUETESAEREO1, payload: data })
			const fn2 = (d) => d({ type: types.OCULTAR_MODAL_AGREGAR_ARCHIVO })
			fn1(dispatch)
			fn2(dispatch)
		}
	}
}


export function crearAprobacionAdicional(aprobador, motivo) {
    const axios = createAxiosInstance();
    return (dispatch, getState) => {
		const errors = validarSolicitudAprobacionAdicional(aprobador, motivo);
		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			});
			return;
		}
		const solicitud = getState().tiquetesaereo.get('solicitud')
		const cotizaciones = solicitud.get('cotizaciones');
		const modificaciones = [];
        if (cotizaciones && cotizaciones.size > 0) {
            cotizaciones.forEach(cotizacion => {
                modificaciones.push({
                    id: null,
                    entity: 'Aprobacione',
                    action: 'add',
                    value: {
                        cotizacion_id: cotizacion.get('id'),
                        aprobador_id: aprobador.id,
                        estado: 1, // Pendiente de aprobación
                        observaciones: motivo,
                        tipo: 3
                    }
                });
            });
        }
        axios.put(`${API_URL}/solicitudes/tiquetes-aereos/${solicitud.get('id')}`, modificaciones)
        .then(res => {
            const solicitud = res.data.solicitud;
            const aprobadores = res.data.aprobadores;
            dispatch({ type: types.OBTENER_SOLICITUD_TIQUETESAEREO, payload: { solicitud, aprobadores } });
            toast.success('Solicitud de aprobación adicional enviada correctamente', { bodyClassName: 'toastify-content toastify-success' });
        })
        .catch(err => {
            displayMessages(dispatch, err);
        });
    }
}


export const validarSolicitudAprobacionAdicional = (aprobador, motivo) => {
    const errors = [];
    if (!aprobador || !aprobador.id) errors.push('Debe seleccionar un aprobador adicional');
    if (!motivo || !motivo.trim()) errors.push('El motivo de la solicitud adicional es obligatorio');
    return errors;
}
























// WEBPACK FOOTER //
// ./src/actions/tiquetesaereo.js